import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '../lib/cn.js';
export const Separator = forwardRef(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (_jsx(SeparatorPrimitive.Root, { ref: ref, decorative: decorative, orientation: orientation, className: cn('shrink-0 bg-[var(--color-border)]', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className), ...props })));
Separator.displayName = SeparatorPrimitive.Root.displayName;
